function removeAsterisks() {
  $('span:contains("**")').text(function(i, txt) {
    return txt.replace('**', '')
  })
  $('span:contains("*")').text(function(i, txt) {
    return txt.replace('*', '')
  })
}

function pushBoldHelpText() {
  $('.bold_help_text').each(function(i) {
    $(this).prependTo(".product__policies")
  })
}

function checkForImage(optionTitle) {
  $('.slider-product-nav .flickity-slider li').each(function(i) {
    var alt_tag = $(this).attr('data-alt-tag');
    if (alt_tag == optionTitle || optionTitle.indexOf(alt_tag) >= 0) {
      var slide_index = $(this).attr('data-flick-index');
      $('.product-detail-carousel').flickity('select', slide_index, !1, !0)
    }
  })
};

function prepProductPage() {
  var prodOpt = $('.product-form__controls-group .selector-wrapper');
  var boldOpt = $('.bold_options .bold_option_set');
  var prodOptCount = $('.product-form__controls-group .selector-wrapper').length;
  var boldOptCount = $('.bold_options .bold_option_set').length;
  if (boldOptCount >= 2 && prodOptCount >= 3) {
    $(boldOpt).each(function() {
      $(this).addClass('extra-options')
    })
  }
  $('.bold_option_swatch').each(function() {
    var countElements = $(this).find('.bold_option_value').length;
    var colsClass = "cols-" + countElements;
    $(this).find('.bold_option_element').wrapAll('<div class="select-images-outer"><div class="select-images-inner"></div></div>');
    $('<div class="txt">Choose an Option</div><div class="close"></div>').prependTo($(this).find('.select-images-inner'));
    $('<div class="select-images-bg"></div>').prependTo($(this).find('.select-images-outer'));
    $(this).append('<div class="option-chooser">Choose an Option<b class="button"></b></div>')
  });
  $('.bold_option_element select').selectric({
    arrowButtonMarkup: '<b class="button"></b>'
  });
  $(".selectric-input").attr("readonly", "readonly");
  totalPHeight = $('header').innerHeight();
  $('.bold_option_swatch').each(function() {
    var selectTitle = $(this).find('.bold_option_title').html().replace('*', '');
    var optionDetails = [];
    $(this).find('.bold_option_value').map(function() {
      var optionTitle = $(this).find('.bold_option_swatch_title').html();
      var optionImage = $(this).find('.bold_option_value_swatch').html();
      if (selectTitle.indexOf('Canopy') >= 0 || selectTitle.indexOf('Canopy Finish') >= 0) {
        optionDetails.push('<div class="option"><div class="option-image">' + optionImage + '</div><div class="option-full"><div class="option-image">' + optionImage + '</div><div class="option-title">' + optionTitle + '</div></div></div>')
      } else if (selectTitle.indexOf('Base') >= 0 || selectTitle.indexOf('Base Finish') >= 0) {
        optionDetails.push('<div class="option"><div class="option-image">' + optionImage + '</div><div class="option-full"><div class="option-image">' + optionImage + '</div><div class="option-title">' + optionTitle + '</div></div></div>')
      } else if (selectTitle.indexOf('Metal') >= 0 || selectTitle.indexOf('Metal Finish') >= 0) {
        optionDetails.push('<div class="option"><div class="option-image">' + optionImage + '</div><div class="option-full"><div class="option-image">' + optionImage + '</div><div class="option-title">' + optionTitle + '</div></div></div>')
      } else {
        optionDetails.push('<div class="option"><div class="option-title">' + optionTitle + '</div>' + '<div class="option-image">' + optionImage + '</div></div>')
      }
    });
    if (selectTitle.indexOf('Canopy') >= 0 || selectTitle.indexOf('Canopy Finish') >= 0) {
      var columnDiv = '<div class="column padB4 full-column-mobile">' + '<div class="canela-title padB2">' + selectTitle + '</div>' + '<div class="details-list">' + optionDetails.join('') + '</div>' + '</div>';
      $(columnDiv).clone().prependTo(".canopy")
    } else if (selectTitle.indexOf('Base') >= 0 || selectTitle.indexOf('Base Finish') >= 0) {
      var columnDiv = '<div class="column padB4 full-column-mobile">' + '<div class="canela-title padB2">' + selectTitle + '</div>' + '<div class="details-list">' + optionDetails.join('') + '</div>' + '</div>';
      $(columnDiv).clone().appendTo(".product-details-columns")
    } else if (selectTitle.indexOf('Metal') >= 0 || selectTitle.indexOf('Metal Finish') >= 0) {
      var columnDiv = '<div class="column padB4 full-column-mobile">' + '<div class="canela-title padB2">' + selectTitle + '</div>' + '<div class="details-list">' + optionDetails.join('') + '</div>' + '</div>';
      $(columnDiv).clone().appendTo(".product-details-columns")
    } else {
      var columnDiv = '<div class="column standard padB4">' + '<div class="canela-title padB2">' + selectTitle + '</div>' + '<div class="details-list">' + optionDetails.join('') + '</div>' + '</div>';
      $(columnDiv).clone().appendTo(".product-details-columns")
    }
  });
  removeAsterisks();
  pushBoldHelpText()
}
const showProductPage = async () => {
  //const result = await prepProductPage();
  $('.product-form, .product-min-price-container').addClass('active');
  $('.option-chooser').on('click', function() {
    $(this).parent().find('.select-images-outer').addClass('active');
    if ($(window).width() <= 650) {
      if ($('.select-images-outer').hasClass("active")) {
        $('#shopify-section-header').addClass('hidden');
        $('.select-images-outer').css('top', '0')
      } else {
        $('#shopify-section-header').removeClass('hidden')
      }
    }
  });
  /*
  $('.bold_option_value').on('click', function(e) {
    $('.bold_option_value').removeClass('active');
    $(this).addClass('active');
    var selectedTextValue = $(this).find('.bold_option_value_title').html();
    var selectorDiv = $(this).parent().parent().parent().parent().find('.option-chooser');
    $(selectorDiv).html(selectedTextValue + '<b class="button"></b>');
    var htmlButtonValue = $('#AddToCart span[data-add-to-cart-text]').html();
    if (htmlButtonValue == "Sold out" || htmlButtonValue == "sold" || htmlButtonValue == "Out of stock" || htmlButtonValue == "out of stock" || htmlButtonValue == "coming soon" || htmlButtonValue == "Coming Soon") {
      $('.product-form__cart-submit').addClass('inactive');
      $('.price-item').addClass('strikethrough')
    } else {
      $('.product-form__cart-submit').removeClass('inactive');
      $('.price-item').removeClass('strikethrough')
    }
    var value_title = $(this).find('.bold_option_value_title').html();
    $('.select-images-outer').delay(800).removeClass('active');
    $('#shopify-section-header').removeClass('hidden')
  })
  */

  let $boldOption = $('.bold_option')

  $boldOption.each(function () {
    let $boldOptionValue = $(this).find('.bold_option_value')

    $boldOptionValue.first().addClass('active');

    $boldOptionValue.on('click', function(e) {
      $boldOptionValue.removeClass('active');
      $(this).addClass('active');
    })
  })



  $('.select-images-inner .close').on('click', function() {
    $('.select-images-outer').removeClass('active');
    $('#shopify-section-header').removeClass('hidden')
  });
  $('.select-images-bg').on('click', function() {
    $('.select-images-outer').removeClass('active');
    $('#shopify-section-header').removeClass('hidden')
  })
}
$(document).ready(function() {
  if ($('.product-detail-carousel').length) {
    var carOptions = {
      contain: !0,
      imagesLoaded: !0,
      prevNextButtons: !1,
      lazyLoad: 2,
      pageDots: !0,
      dragThreshold: 0
    };
    $('.product-detail-carousel').flickity(carOptions);
    var navOptions = {
      contain: !0,
      pageDots: !1,
      prevNextButtons: !1,
      initialIndex: 0,
      freeScroll: !0,
      freeScrollFriction: 0.03,
      dragThreshold: 5,
      cellAlign: 'left',
      asNavFor: '.product-detail-carousel'
    };
    $('.slider-product-nav').flickity(navOptions);
    $('.slider-product-nav li').each(function(i) {
      var slide_index = $(this).attr('data-flick-index');
      if ($(this).hasClass('selected_variant')) {
        $('.product-detail-carousel').flickity('select', slide_index, !1, !0)
      }
    })
  }
  if ($('.client-gallery-carousel').length) {
    $('.client-gallery-carousel').on('init', function(event, slick, currentSlide, nextSlide) {
      var client_gallery_length = $('.client-gallery-carousel .slick-slide').length;
      if (slick.currentSlide <= slick.slideCount - slick.options.slidesToShow) {
        $('.client-gallery-nav .arrow.next').addClass('active')
      }
    });
    $('.client-gallery-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide) {
      if (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
        $('.client-gallery-nav .arrow.next').removeClass('active')
      } else {
        $('.client-gallery-nav .arrow.next').addClass('active')
      }
      if (slick.currentSlide == 0) {
        $('.client-gallery-nav .arrow.prev').removeClass('active')
      } else {
        $('.client-gallery-nav .arrow.prev').addClass('active')
      }
    });
    // $('.client-gallery-carousel').slick({
    //   infinite: false,
    //   variableWidth: true,
    //   adaptiveHeight: false,
    //   edgeFriction: false,
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   responsive: [{
    //     breakpoint: 1024,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       centerMode: false
    //     }
    //   }]
    // });
    $('.template-product.new .client-gallery-carousel').slick({
      infinite: false,
      variableWidth: true,
      adaptiveHeight: true,
      edgeFriction: false,
      // slidesToShow: 2,
      // slidesToScroll: 1,
      // responsive: [{
      //   breakpoint: 1024,
      //   settings: {
      //     slidesToShow: 2,
      //     slidesToScroll: 1,
      //     centerMode: false
      //   }
      // }]
    });
    $('.client-gallery-carousel').on('swipe', function(event, slick, direction) {
      var currentSlide = $('.client-gallery-carousel').slick('slickCurrentSlide')
    });
    $('.client-gallery-nav .right-arr.arrow').click(function() {
      $(".client-gallery-carousel").slick('slickNext')
    });
    $('.client-gallery-nav .left-arr.arrow').click(function() {
      $(".client-gallery-carousel").slick('slickPrev')
    });
    $('.client-gallery-carousel').slickLightbox({
      itemSelector: 'a.thumbnail',
      background: '#fff'
    })
  }
  if ($('.accordion-row').length) {
    $(".accordion-row .container").accordion({
      collapsible: !0,
      animate: 500,
      heightStyle: "content",
      active: !1
    })
  }
  if ($('select.single-option-selector').length) {
    $('select.single-option-selector').selectric({
      arrowButtonMarkup: '<b class="button"></b>'
    })
  }
  if ($('#shopify-section-product-template-new-shop').length) {
    setTimeout(function() {
      showProductPage()
    }, 900)
  }
  $('.selectric-items li').on('click', function() {
    var htmlButtonValue = $('#AddToCart span[data-add-to-cart-text]').html();
    if (htmlButtonValue == "Sold out" || htmlButtonValue == "sold" || htmlButtonValue == "Out of stock" || htmlButtonValue == "out of stock" || htmlButtonValue == "coming soon" || htmlButtonValue == "Coming Soon") {
      $('.product-form__cart-submit').addClass('inactive');
      $('.price-item').addClass('strikethrough')
    } else {
      $('.product-form__cart-submit').removeClass('inactive');
      $('.price-item').removeClass('strikethrough')
    }
    var listItemHTML = $(this).html();
    if ($(this).parent().parent().parent().parent().parent().find('label').html() == "Glass Size" || $(this).parent().parent().parent().parent().parent().find('label').html() == "Size") {
      $('.from').css('display', 'none')
    }
    var value_title = $(this).html();
    if (value_title) {
      checkForImage(value_title)
    }
  });
  $('.bold_option_value').on('click', function(e) {
    var value_title = $(this).find('.bold_option_value_title').html();
    if (value_title) {
      checkForImage(value_title)
    }
  });
  
  if (/Mobi/.test(navigator.userAgent)) {
    $('.selector-wrapper select').on('change', function() {
      var value_title = $(this).parent().parent().find('li.selected').html().toString();
      var hasNumber = /\d/.test(value_title);
      if ($('label').html() == "Glass Size" || $('label').html() == "Size") {
        $('.from').css('display', 'none')
      }
      if (value_title != "" && hasNumber == !1) {
        checkForImage(value_title);
        $('html,body').animate({
          scrollTop: 0
        }, 800)
      }
    })
  }
})


